import { useState, useEffect, useCallback } from 'react';
import Button from '../components/Button';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

import { SaveOne, SeedProvincia, SeedMunicipio, SeedPais, GetWA } from '../utils/bridge';
import Spinner  from '../utils/Spinner';
import { useGoToStep } from '../hooks/useGoToStep';

import './css/bootstrap.min.css';
import './css/estilo.css';

import { logMessage } from '../hooks/logger';

import toast, { Toaster, ToastBar } from 'react-hot-toast';

import { useInputChanged } from "../context/InputChangedContext";


const Paso1 = ({ usr }) => {

    const { setInputChanged, setValidDataInputs } = useInputChanged();

    const [formData, setFormData] = useState({
        direccion: '',
        ciudad: '',
        provincia: '',
        postal: '',
        municipio: '',
        pais: '',        
        telefono: '',
        celular: '',
        correo: '',
        sector: '',
        correouser: usr,
        result: ['', '']
    });

    const [validError, setValidError] = useState('');
    const [isInitialLoad, setInitialLoad] = useState(true);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    
    useEffect(() => {
        if (usr) {
            setFormData((prevState) => ({
                ...prevState,
                correouser: usr
            }));
        }
    }, [usr]);


    const [isUnsave, setIsUnsave] = useState(false);


    const navigate = useNavigate();


    useEffect(() => {
        setIsUnsave(
            formData.direccion !== '' || formData.ciudad !== '' || formData.provincia !== '' || formData.postal !== ''
            || formData.municipio !== '' || formData.pais !== '' || formData.telefono !== '' || formData.celular !== '' 
            || formData.correo !== '', formData.sector !== ''
        );

        //console.log(formData);

    }, [formData]);

    useEffect(() => {
        
        const unsave = 
        formData.direccion !== '' || formData.ciudad !== ''    || formData.provincia !== '' ||
        formData.postal !== ''    || formData.municipio !== '' || formData.pais !== '' ||
        formData.telefono !== ''  || formData.celular !== ''   || formData.correo !== '' ||
        formData.sector !== '';

        setInputChanged(unsave);

        // calcula si el formulario está completo
        const valid = 
        !!formData.direccion.trim() && !!formData.ciudad.trim() &&
        !!formData.postal.trim() && !!formData.provincia.trim() &&
        !!formData.municipio.trim() && !!formData.pais.trim() &&
        !!formData.telefono.trim() && !!formData.celular.trim() &&
        !!formData.correo.trim() && !!formData.sector.trim();

        setValidDataInputs(valid);
    }, [formData, setInputChanged, setValidDataInputs]);

    


    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'telefono' || name === 'celular') {
            let digitos = value.replace(/\D/g, '');
            const codigoAreaDominicano = /^(809|829|849)/.test(digitos);

            //revisamos si es 1809/1829/1849, ese "1" es un dolor de cabeza
            if (/^(1809|1829|1849)/.test(digitos)) {
                digitos = digitos.slice(1); // eliminamos el '1' inicial
            }

            //const newVal = value.replace(/[^0-9-]/g, '').slice(0,12);

            let newVal;
            if (codigoAreaDominicano) {
                
                if (digitos.length <= 3) {
                        newVal = digitos;
                } else if (digitos.length <= 6) {
                        newVal = digitos.slice(0, 3) + '-' + digitos.slice(3);
                } else {
                        newVal = digitos.slice(0, 3) + '-' + digitos.slice(3, 6) + '-' + digitos.slice(6, 10);
                }
            } else {
                // Para internacionales, no formatear (solo limitar la longitud si quieres)
                newVal = digitos.slice(0, 16); // puedes ajustar 15 como máximo permitido
            }
            setFormData((prevState) => ({
                ...prevState,
                [name]: newVal
            }));

        } else {
            setFormData((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }
    };


    const handleClickSubmit = (e) => {
        e.preventDefault();
        alert('submitted');
    };


    const validateError = () => {
        const errors = {};
        if (!formData.direccion.trim()) errors.direccion = 'Completar el campo dirección es obligatorio';
        if (!formData.ciudad.trim()) errors.ciudad = 'Completar el campo ciudad es obligatorio';
        if (!formData.postal.trim() && formData.provincia.trim()) errors.postal = 'Indicar código postal';
        if (!formData.provincia.trim()) errors.provincia = 'La provincia es un campo obligatorio';
        if (!formData.municipio.trim()) errors.municipio = 'El municipio es un campo obligatorio';
        if (!formData.pais.trim()) errors.pais = 'El pais es un campo obligatorio';
        if (!formData.telefono.trim()) errors.telefono = 'Completar el campo teléfono es obligatorio';
        if (!formData.celular.trim()) errors.celular = 'Completar el campo celular es obligatorio';
        if (!formData.correo.trim()) errors.correo = 'El correo electrónico personal es obligatorio';
        if (!formData.sector.trim()) errors.sector = 'Completar el campo sector es obligatorio';

        return errors;
    }


    /*const handleSubmit = async (e) => {
        e.preventDefault();


        const errors = validateError();
        if (Object.keys(errors).length > 0) {
            setValidError(errors);
            return;
        }

        setValidError({});

        const save = async () => { 
            setInitialLoad(true);            
            try {                
                const res = await axios.post(`${SaveOne}`, formData); 
                toast.success(`${res.data.datos}`);               
            } catch (error) {
                if (error.response) {                    
                    //console.log(error.response.data.mensajeError)
                    const errorMessage = error.response.data.mensajeError;
                    logMessage('Error', 'Error del servidor al guardar los datos', error.response.data);
                    logMessage('Informacion!', 'Paso 1: Un error fue encontrado!', error.response);
                    toast.error(`${errorMessage}`);
                } else {
                    toast.error(`Error: sin respuesta del servidor`);
                    logMessage('Error', 'Sin respuesta del servidor', error.response.data);
                }
                logMessage('Error', 'Error al guardar los datos', error);
            }finally{
                setInitialLoad(false); 
            }
        }

        save();
    }*/

    const save = useCallback(async () => {
        setInitialLoad(true);
        try {
            const res = await axios.post(`${SaveOne}`, formData);
            toast.success(`${res.data.datos}`);
        } catch (error) {
            toast.error("Error al guardar los datos");
        } finally {
            setInitialLoad(false);
        }
    }, [formData]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateError();
        if (Object.keys(errors).length > 0) {
            setValidError(errors);
            return;
        }
        setValidError({});
        await save();
    };

    const { setSaveFn } = useInputChanged();
    useEffect(() => {
        setSaveFn(() => save);
    }, [save, setSaveFn]);
    
    const capitalLetter = (word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    const [provincia, setProvincia] = useState([]);
    const [municipio, setMunicipio] = useState([]);
    const [pais, setPais] = useState([]);


    const InitialLoad = async () => {
         axios.get(`${SeedProvincia}`).then(response => {
            //const orderedRes = response.data.sort((a, b) => capitalLetter(a.nombre).localeCompare(capitalLetter(b.nombre)));            
            setProvincia(response.data);
        }).catch(error => {
            if (error.response) {
                console.error('⚠ Error del servidor (4xx,5xx provincia):', error.response.status);
                logMessage('Error', '⚠ Error del servidor (4xx,5xx provincia):', error.response.status);
            } else if (error.request) {
                console.error('No se pudo conectar (API caída, red, CORS bloqueado)');
                logMessage('Error', '⚠ No se pudo conectar (API caída, red, CORS bloqueado):', error.request);
            } else {
                console.error('Error desconocido: ', error.message);
                logMessage('Error', '⚠ Paso 1: Error desconocido:', error.message);
            }
        });

        axios.get(`${SeedMunicipio}`).then(response => {
            //const orderedRes = response.data.sort((a, b) => a.nombre.localeCompare(b.nombre));            
            let municipios = [...response.data].sort((a, b) => a.nombre.localeCompare(b.nombre));
            // Busca el índice de "Distrito Nacional"
            /*const idx = municipios.findIndex(m => m.nombre === "SANTO DOMINGO ESTE");
            if (idx > -1) {
                // Extrae el municipio y lo coloca al inicio
                const distrito = municipios.splice(idx, 1)[0];
                municipios.unshift(distrito);
            }*/
            
            setMunicipio(municipios);
        }).catch(error => { 
            console.error("Error municipio data loading: ", error);
            logMessage('Error', '⚠ Error municipio data loading:', error);
        });

        axios.get(`${SeedPais}`).then(response => {
            const orderedPais = response.data.sort((a, b) => a.nombre.localeCompare(b.nombre));            
            const idx = orderedPais.findIndex(m => m.nombre === "REPÚBLICA DOMINICANA");
            if (idx > -1) {
                // Extrae el municipio y lo coloca al inicio
                const paises = orderedPais.splice(idx, 1)[0];
                orderedPais.unshift(paises);
            }
            
            setPais(orderedPais);
        }).catch(error => { 
            console.error("Error pais data loading: ", error);
            logMessage('Error', '⚠ Error pais data loading:', error); 
        });


        const responseGet =  axios.get(`${GetWA}/${usr}`).then(response => {
            if (response.data) {
                setFormData({ ...formData, ...response.data });                    
            }
        }).catch(error => {
            if (error.response) {
                console.error('⚠ Error del servidor (4xx,5xxg):', error.response.status);
                logMessage('Error', '⚠ Error del servidor (4xx,5xxg):', error.response.status);
            } else if (error.request) {
                console.error('No se pudo conectar (API caída, red, CORS bloqueadog)');
                logMessage('Error', '⚠ No se pudo conectar (API caída, red, CORS bloqueadog):', error.request);
            } else {
                console.error('Error desconocidog: ', error.message);
                logMessage('Error', '⚠ Paso 1: Error desconocido:', error.message);
            }
        });

        setInitialLoad(false);
    }


    useEffect(() => {

        if (isInitialLoad) {
             InitialLoad();
        }

    }, []);

    //const { setHasUnsavedChanges } = useFormChanges();

    const validDataInputs =
        !!formData.direccion.trim() &&
        !!formData.ciudad.trim() &&
        !!formData.postal.trim() &&
        !!formData.provincia.trim() &&
        !!formData.municipio.trim() &&
        !!formData.pais.trim() &&
        !!formData.telefono.trim() &&
        !!formData.celular.trim() &&
        !!formData.correo.trim();

    const { goToStep, ConfirmModal, IncompleteModal } = useGoToStep(save);

    if (isInitialLoad) return <Spinner />;

    return (

        <div>
            
            <div className="encab-contenido">
                <h1>Actualización de datos personales y laborales</h1>
            </div>

            <div className="pasos">
                <Link /*to="/paso1"*/ className="ant deshab"><span className="visually-hidden">Ir al paso</span> <span className="visually-hidden d-lg-block">Anterior</span></Link>
                <h2>Paso 1 de 4</h2>
                <Link /*to="/paso2"*/ className="sig" onClick={(e) => goToStep(e, "paso2")}><span className="visually-hidden">Ir al paso</span> <span className="visually-hidden d-lg-block">Siguiente</span></Link>
            </div>

            <h3>Datos residencia habitual</h3>


            <form onSubmit={handleClickSubmit}>
                <div className="row">
                    <div className="col">
                        <label htmlFor="text-direccion" className="form-label"><strong>Dirección:</strong></label>
                        <input
                            type="text"
                            id="text-direccion"
                            name="direccion"                            
                            value={formData.direccion || ''}                            
                            onChange={handleChange}
                            className="form-control"
                            aria-describedby="ayuda-formato-direccion"
                        />
                        <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.direccion ? 'red' : 'gray' }}>
                                {validError.direccion ? validError.direccion : 'Calle, número de casa, edificio y sector.'}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 mt-3">
                        <label htmlFor="text-ciudad" className="form-label"><strong>Ciudad:</strong></label>
                        <input
                            type="text"
                            id="text-ciudad"
                            name="ciudad"
                            value={formData.ciudad || ''}
                            onChange={handleChange}
                            className="form-control"
                        />
                        <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.ciudad ? 'red' : 'gray' }}>
                                {validError.ciudad ? validError.ciudad : ''}
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6 mt-3">
                        <label htmlFor="text-sector" className="form-label"><strong>Sector:</strong></label>
                        <input
                            type="text"
                            id="text-sector"
                            name="sector"
                            value={formData.sector || ''}
                            onChange={handleChange}
                            className="form-control"
                        />
                        <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.sector ? 'red' : 'gray' }}>
                                {validError.sector ? validError.sector : ''}
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6 mt-3">
                        <label htmlFor="select-provincia" className="form-label"><strong>Provincia:</strong></label>
                        <select id="select-provincia" value={formData.provincia || '00'} name="provincia" className="form-select" onChange={handleChange} >
                            <option value="00" disabled> Seleccionar de la lista </option>
                            {provincia.map(p => (
                                <option key={p.id} value={p.id}>
                                    {p.nombre}
                                </option>
                            ))}
                        </select>

                        <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.provincia ? 'red' : 'gray' }}>
                                {validError.provincia ? validError.provincia : ''}
                            </p>
                        </div>
                    </div>

                </div>

                <div className="row">
                    <div className="col-md-6 mt-3">
                        <label htmlFor="text-postal" className="form-label"><strong>Código postal:</strong></label>
                        <input
                            type="text"
                            id="text-postal"
                            name="postal"
                            value={formData.postal || ''}
                            onChange={handleChange}
                            className="form-control" />
                        <p style={{ color: validError.postal ? 'red' : 'gray' }}>
                            {validError.postal ? validError.postal : ''}
                        </p>
                    </div>
                    <div className="col-md-6 mt-3">
                        <label htmlFor="select-municipio" className="form-label"><strong>Municipio:</strong></label>
                        <select id="select-municipio" value={formData.municipio || '00'} name="municipio" className="form-select" onChange={handleChange}>
                            <option value="00" disabled> Seleccionar de la lista </option>
                            {municipio.map(m => (
                                <option key={m.id} value={m.id}>
                                    {m.nombre}
                                </option>
                            ))}
                        </select>
                        <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.municipio ? 'red' : 'gray' }}>
                                {validError.municipio ? validError.municipio : ''}
                            </p>
                        </div>                       
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 mt-3">
                        <label htmlFor="select-pais" className="form-label"><strong>País:</strong></label>
                        <select id="select-pais" value={formData.pais || '00'} name="pais" className="form-select" onChange={handleChange}>
                            <option value="00" disabled> Seleccionar de la lista </option>
                            {pais.map(p => (
                                <option key={p.id} value={p.id}>
                                    {p.nombre}
                                </option>
                            ))}
                        </select>
                        <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.pais ? 'red' : 'gray' }}>
                                {validError.pais ? validError.pais : ''}
                            </p>
                        </div>                     
                    </div>
                    <div className="col-md-6 mt-3">
                        <label htmlFor="tel-telefono" className="form-label"><strong>Teléfono:</strong></label>
                        <input
                            type="text"
                            id="tel-telefono"
                            name="telefono"
                            value={formData.telefono || ''}
                            onChange={handleChange}
                            className="form-control"
                            aria-describedby="ayuda-formato-telefono"
                            pattern="[0-9\-]+"
                        />
                        <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.telefono ? 'red' : 'gray' }}>
                                {validError.telefono ? validError.telefono : 'Solo ingresar números y guiones'}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 mt-3">
                        <label htmlFor="tel-celular" className="form-label"><strong>Celular:</strong></label>
                        <input
                            id="tel-celular"
                            name="celular"
                            value={formData.celular || ''}
                            onChange={handleChange}
                            className="form-control"
                            aria-describedby="ayuda-formato-celular"
                            type="tel"
                            pattern="[0-9\-]+" />{/*solo números y guiones*/}
                        <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.celular ? 'red' : 'gray' }}>
                                {validError.celular ? validError.celular : 'Solo ingresar números y guiones'}
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6 mt-3">
                        <label htmlFor="email-correo" className="form-label"><strong>Correo electrónico personal:</strong></label>
                        <input
                            id="email-correo"
                            name="correo"
                            value={formData.correo || ''}
                            onChange={handleChange}
                            className="form-control"
                            type="email" />
                        <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.correo ? 'red' : 'gray' }}>
                                {validError.correo ? validError.correo : ''}
                            </p>
                        </div>
                    </div>
                </div>

                <span className="separador"></span>

                <div className="form-botones">
                    <Button children="Guardar" onClick={handleSubmit} variant='primary'></Button>                    
                </div>
            </form>
            <Toaster position="top-center" reverseOrder={false} />
            {/* Modal */}
                <ConfirmModal />
                <IncompleteModal />
            {/* Fin Modal */}
        </div>
        
    );
}




export default Paso1;